import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, MessageSquare, MoreHorizontal, X } from 'lucide-react';
import { Button } from './Button';
import { Input } from './Input';
import { ScrollArea } from './ScrollArea';
import { Chat, Project } from '../types';
interface ChatHistoryPanelProps {
  isOpen: boolean;
  onClose: () => void;
  chats: Chat[];
  projects: Project[];
  activeChatId: string | null;
  onSelectChat: (id: string) => void;
}
export function ChatHistoryPanel({
  isOpen,
  onClose,
  chats,
  projects,
  activeChatId,
  onSelectChat
}: ChatHistoryPanelProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredChats = chats.filter(chat => chat.title.toLowerCase().includes(searchQuery.toLowerCase()));
  const mainChats = filteredChats.filter(chat => !chat.projectId);
  return <AnimatePresence data-id="element-80">
      {isOpen && <motion.div initial={{
      width: 0,
      opacity: 0
    }} animate={{
      width: 280,
      opacity: 1
    }} exit={{
      width: 0,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: 'easeInOut'
    }} className="h-full bg-[#1a1e2e] border-r border-white/5 flex flex-col flex-shrink-0 overflow-hidden" data-id="element-81">
          <div className="w-[280px] h-full flex flex-col" data-id="element-82">
            <div className="p-4 flex items-center justify-between border-b border-white/5" data-id="element-83">
              <h2 className="text-sm font-semibold text-slate-200 tracking-wide" data-id="element-84">
                Chat History
              </h2>
              <Button variant="ghost" size="icon" onClick={onClose} className="h-6 w-6 text-[#6b7194] hover:text-white" data-id="element-85">
                <X className="h-4 w-4" data-id="element-86" />
              </Button>
            </div>

            <ScrollArea className="flex-1 px-2 py-4" data-id="element-87">
              <div className="px-2 mb-4" data-id="element-88">
                <div className="relative" data-id="element-89">
                  <Search className="absolute left-2.5 top-2 h-3.5 w-3.5 text-[#6b7194]" data-id="element-90" />
                  <Input placeholder="Search chats..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="h-8 pl-8 bg-black/20 border-transparent focus-visible:ring-1 focus-visible:ring-[#4a4f6a] text-xs placeholder:text-[#6b7194]" data-id="element-91" />
                </div>
              </div>

              {/* Flat Chat List */}
              <div className="space-y-0.5" data-id="element-92">
                {mainChats.map(chat => <ChatItem key={chat.id} chat={chat} isActive={activeChatId === chat.id} onClick={() => onSelectChat(chat.id)} data-id="element-93" />)}
              </div>
            </ScrollArea>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
function ChatItem({
  chat,
  isActive,
  onClick
}: {
  chat: Chat;
  isActive: boolean;
  onClick: () => void;
}) {
  return <div className="group relative px-2" data-id="element-94">
      <Button variant="ghost" onClick={onClick} className={`w-full justify-start h-8 px-2 font-normal ${isActive ? 'bg-[#252a42] text-white' : 'text-[#8b8fa8] hover:bg-white/5 hover:text-slate-200'}`} data-id="element-95">
        <MessageSquare className={`h-3.5 w-3.5 mr-2 flex-shrink-0 ${isActive ? 'text-emerald-400' : 'opacity-70'}`} data-id="element-96" />
        <span className="truncate text-sm" data-id="element-97">{chat.title}</span>
      </Button>

      <div className={`absolute right-3 top-1/2 -translate-y-1/2 flex items-center ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} data-id="element-98">
        <div className={`h-8 w-8 absolute right-0 bg-gradient-to-l from-[#1a1e2e] to-transparent pointer-events-none ${isActive ? 'from-[#252a42]' : 'group-hover:from-[#1f2336]'}`} data-id="element-99" />
        <Button variant="ghost" size="icon" className="h-6 w-6 relative z-10 text-[#6b7194] hover:text-white hover:bg-[#2a2f42]" data-id="element-100">
          <MoreHorizontal className="h-3.5 w-3.5" data-id="element-101" />
        </Button>
      </div>
    </div>;
}